module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chpt"
  }, [_c('span', {
    staticClass: "textStyle4"
  }, [_vm._v("CHAPTER")]), _c('br'), _c('span', {
    staticClass: "textStyle11"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("O")]), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("n the second morning back, Atkins said as he presented his coffee, ‘Garden’s a jungle.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘What, out back?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘Yes, that one. I thought I’d hang your suits out there. What a hope! Need a map to find the garden wall.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘Start weeding.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘My hat.’ Atkins was many things but not a gardener. He poured Denton’s coffee and said, ‘Find us somebody with a strong back and a deal of patience.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘Aren’t there gardening agencies?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘There’s everything; this is London. You want an egg? I had one. Quite good. Or a kipper.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘Why do you buy kippers? You know I don’t like them.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘I do.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘Poached, on toast, bacon.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘If you care, the parlourmaid next door but one says the madam there complains that the seeds from our weeds are spoiling her garden.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘I’ll get somebody—dear God, we just got back!’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘Middle-class respectability. Weeds not respectable. Preserve with your toast?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘Is that the same as jam? Yes, jam.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Atkins padded off downstairs—he affected Prince Albert slippers in the house—with Rupert puffing behind him. Until his breakfast came, Denton worked on the novel, a writing tablet in his lap, the words coming faster than he could move the pen. It would be all right now: the book was still in his head, perhaps with a vividness it had lacked when first created, needing only to be set down. He hurried because he didn’t want to forget it, yes, but he hurried also because money, finally, was the issue, not art: without the novel, he would come on hard times in eight or ten months. With it, he could look ahead a year and a half, time to write something else.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Atkins brought the first mail of the day at ten—bills (how could there be bills when he hadn’t been there?), four dinner invitations he’d refuse—then lunch at twelve from the public house next door, the Lamb. At two, he was back with more mail, this time including an answer from Aubrey Heseltine:")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Would Mr Denton care to drop by Albany 134-B tomorrow between two and five?")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Mr Denton supposed he would.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("At four, he stopped. He had written thirty-seven pages. If it hadn’t been Janet Striker he was stopping for, he’d have gone on. And on, although he knew it was better to stop, better to leave some water in the bucket for tomorrow.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("He accepted Atkins’s advice about clothes. Atkins of course knew without his saying so that he was going to meet Mrs Striker; Atkins wasn’t above doing archaeology in his wastebasket. A dark frock coat, grey waistcoat, subdued necktie. He rejected lavender although told the colour was ‘immensely fashionable’. A soft hat, but with a narrower brim than he really liked.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘This ain’t the Wild West, General.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("He walked again to Lloyd Baker Street and dropped off the day’s work. As he had the day before, he behaved like a guilty man (what was it about the typewriter—she was a mouse), stopping to pretend to look at houses, trees, birds, then covertly looking back down the way he had come. Had he seen anybody? He couldn’t be sure. Nobody he saw twice, certainly—nobody he could run after. He told himself he was still disoriented from the trip and fled from the typewriter’s, first down Goswell Road, then Aldersgate, finally to the ABC on Barbican—fifteen minutes early, even though it was no good being early; she would be on time. He didn’t fancy sitting in the tea shop alone. He walked, thinking about the novel, about her, about Mary Thomason, who had sent him a letter and might be dead or married or living at home by now. Nobody following; he’d checked again and again. When he finally got to the ABC a second time, he was ten minutes late.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("She was, of course, there. She was sitting at a far table, wearing as always an unattractive black hat, a dress that even he knew was years out of fashion—something about the widely puffed sleeves. She turned her head and saw him and he felt a pang of sadness for her: the knife slash down her face was now a red ribbon that seemed to have escaped from her hat. It was nothing she could or did try to hide; seeing him, she even seemed to turn the left side of her face more towards him as if to display it.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘I’m late. I’m sorry I’m late. I didn’t want to be early.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘I was early.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘I came by before—maybe you were already here.’ It was a ridiculous conversation. He had known they wouldn’t pick up where they had left off six months before—that grudging and hard-won, only partial intimacy—but this was worse, almost like a first time. He sat, then got himself tea at her urging, some kind of supposedly edible bun, put it down on the table, where it sat, uneaten, for as long as they were there. He thanked her for her letters, explained about the package that had come the day before.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("She hardly spoke. It became terrible—long silences, questions that got one-syllable answers. The trivial and the obvious. He said, ‘And your mother?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Her mother had in effect sold her when she was seventeen; the husband was older, brutal, had put her in a mental institution when she had rebelled. She smiled with one side of her face— the unscarred side. ‘My mother is being seen to.’ She looked up from the teacup she was using to make overlapping rings on the tablecloth. ‘She is senile, and, as you know, a drunkard. I stood it as long as I could. She’s in a house with three other old women and a matron of sorts who cares for them.’ She put the cup down in its saucer. ‘She’s dying.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘I’m sorry.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘Oh, don’t say things like that, Denton! I can’t be sorry; why should you? I’m sorry")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("for")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("her, but not")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("sorry")]), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v(".’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("He told her about Mary Thomason. She seemed uninterested. Her life was spent counselling prostitutes in how to get off the street, find work; she hadn’t much use, he supposed, for nice young women. She had been a prostitute herself, ‘never a very good one’. He tried to think of funny stories from his months away, but they fell flat. Out of nowhere, she said, ‘I’m going to be fairly well off.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘Money?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘The suit’s being settled.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("He remembered. She’d sued an Oxford college for her share of her husband’s estate after he’d changed his will and shot himself. The case had been going on for fourteen years. She said, ‘They tried to wear me out, but I got too expensive. I’m to get half the estate plus the pension that should have been my mother’s payment for turning me over to him.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘You can stop working.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘Can I? And do what? Become one of the women I despise? Go to live in Florence?’ She stared into the teacup, rubbed the rings she’d made with her finger. She said, ‘I’m sorry, Denton. I’m being unpleasant.’ She looked up. ‘You thought it would be different, didn’t you?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘I thought—’ She made him angry when she was like this. ‘Yes, I thought it would be different.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘So did I. I thought we would—’ She got up. ‘Let’s walk.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("It was still light outside, full daylight but of a colour that seemed ominous, a yellow-green; the air was sultry, wrong for late September. He wondered what he had done to spoil things; it couldn’t all be her doing. ‘I’m sorry,’ he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("She put her hand in his arm.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("They turned into Aldersgate and walked towards St Paul’s, then diverted towards the tangle of Little Britain. He suggested dinner but she said she couldn’t. She never gave explanations. ‘Couldn’t’ might simply mean that she wouldn’t. He had thought that he might be able to whisk her off to the Café Royal, a place he liked and in which he felt comfortable, but of course she wouldn’t. Perhaps it was the scar, which ran from cheekbone to chin, that was behind that ‘couldn’t’.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("As if tuned to his thought, she said, ‘You saw the scar.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘Of course.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘The doctors wanted to operate again and hide it somehow. I don’t think they really knew what they’d do.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘Now you’ll have the money.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘That isn’t the point.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘No, of course. But don’t you—’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘The women are afraid of it. It’s got hard for me to talk to some of them. They see it and they think, “That’s what could happen to me, some man,” and they don’t want to be reminded of that part of their lives, and they stay away from me. If I were going to stay, I’d tell the doctors to have a go, but I’m not. I don’t give a damn what other people think.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘Least of all men.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("She hesitated. ‘Most men.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘Me?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘You’re always the exception. That’s why I—’ She teetered on the edge of saying it, and he stopped so that she’d stop, too, but she pulled her hand away from his arm and he saw that he’d lost the moment.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘Janet—’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘Don’t—please—’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘Janet, I want—’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘Don’t tell me what you want!’ She backed away. A man going by had to veer around her, looked at them angrily. She paid no attention. ‘You’re moving too fast.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘For God’s sake, Janet, I’ve been away six months! Things didn’t just stand still for me; I—’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘Don’t tell me!’ She looked her worst then—red-faced, gaunt, absurdly dressed. She had told him once that she’d been a pretty girl, the reason her mother had ‘got a good price’ for her, but nearly five years in a prison for the criminally insane had worked on her like a holystone. Now, in her late thirties, she could never be thought ‘pretty’, seldom even handsome. But her face was passionate and intelligent, contorted now with her fear of him. ‘Don’t draw me in!’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘Janet, I want to be with you.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("She made an impatient gesture with her right hand, as if she were pushing away a child or an animal. ‘Oh, I wish I’d never met you!’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘You don’t mean that!’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Two people coming towards them separated and went around, both pretending not to see them. She waited for them to go on and said, sagging, ‘No, I don’t mean that. But I wish I did!’ She started off in the direction they had come. ‘Don’t follow me! I mean it. Give me a day—two days—’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘I don’t even know where you live.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("He had followed her a few steps despite what she’d said; they had both stopped again. She waited, looking down at St Paul’s as if expecting the dome to tell her what to say. ‘I’ll write to you.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘If you write, it’ll be too easy to say you don’t want to see me. I want us to meet.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("‘Yes. Yes, that was cowardly of me.’ She held up a hand as if to push him off. ‘I’ll write to you where and when.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("And she strode away.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("He looked after her. He was enraged and saddened, the two feelings wound together. She was ugly, he told himself; she was cold; what sort of hold could such a woman have over him? But it was no good. The hold was real.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("He turned his head back towards St Paul’s in time to see a figure change its course and disappear into what seemed a solid wall. The movement had been furtive, he thought; Atkins’s ‘rum type’ came to him. The change of direction, the movement could have been those of somebody following him, thinking himself seen and dodging into a doorway.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("It was what his anger needed. Feeding on it, he charged down Little Britain Street and found a gap where the figure had disappeared. He came into a wider lane, blue-grey sky darkening overhead. He saw openings to his left and ahead, chose the second, plunged on, his long legs like scissors cutting up the distance.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Ahead was a cul-de-sac; another opening, barely an alleyway, opened to his right. He turned into it and found his way blocked fifty feet on by a wooden gate higher than his head. It was another small courtyard, grimy windows looking down on him, a single doorway up two feet off the pavement with no steps to it, above it a gallows-like beam meant to hold a block and tackle. The place felt unused and dusty, as if he’d opened a door on it that had been locked for decades. Not even a pigeon.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Chasing spooks.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("He decided to take his ghosts to some place that served alcohol.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6af5a720","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Chapter03.vue
// module id = 78
// module chunks = 0